import React from "react";
import { Award } from "lucide-react";

import heroImg from "../../../Images/hero-villa.jpg";
import cityImg from "../../../Images/city-skyline.jpg";
import interiorImg from "../../../Images/apartment-interior.jpg";
import towerImg from "../../../Images/property-tower.jpg";


// function WinnersWallOfFame() {
//   const fame = [
//     {
//       rank: "01",
//       title: "Aurum Vistas",
//       sub: "Project of the year 2025",
//       value: "₹4.8 Cr",
//       units: "84 sold",
//       featured: true,
//     },
//     {
//       rank: "02",
//       title: "Skyline Lofts",
//       sub: "Most-watched launch",
//       value: "₹2.1 Cr",
//       units: "62 sold",
//     },
//   ];

//   return (
//     <section className="ws-fame">
//       {/* same JSX from original component */}
//     </section>
//   );
// }

// export default WinnersWallOfFame;

export function WinnersWallOfFame() {
  const fame = [
    { rank: "01", title: "Aurum Vistas", sub: "Project of the year 2025", value: "₹4.8 Cr", units: "84 sold", featured: true, img: heroImg, },
    { rank: "02", title: "Skyline Lofts", sub: "Most-watched launch", value: "₹2.1 Cr", units: "62 sold", img: towerImg, },
    { rank: "03", title: "Maison Dwarka", sub: "Top boutique residence", value: "₹3.1 Cr", units: "48 sold", img: interiorImg, },
    { rank: "04", title: "Linea Quartier", sub: "Best mid-rise community", value: "₹1.6 Cr", units: "120 sold", img: heroImg, },
    { rank: "05", title: "Aria Greens", sub: "Top sustainable project", value: "₹2.4 Cr", units: "96 sold", img: cityImg, },
  ];

  return (
    <section className="ws-fame">
      <div className="ws-fame-glow" />
      <div className="ws-fame-inner">
        <div className="ws-fame-head">
          <span className="ws-section-eyebrow"><Award size={12} /> Wall of fame</span>
          <h2 className="ws-section-heading">The properties our community <em>loved most</em>.</h2>
        </div>

        <div className="ws-fame-grid">
          {fame.map((f) => (
            <article className={`ws-fame-card${f.featured ? " featured" : ""}`} key={f.rank}>
              <div
                className="ws-fame-bg"
                style={{ backgroundImage: `url(${f.img})` }}
              />


              <div className="ws-fame-content">

                {/* <div className="ws-fame-image">
                <img src={f.img} alt={f.title} />
              </div> */}
                <div className="ws-fame-rank">{f.rank}</div>
                <div>
                  <h3>{f.title}</h3>
                  <p>{f.sub}</p>
                  <div className="ws-fame-meta">
                    <span>From <strong>{f.value}</strong></span>
                    <span>{f.units}</span>
                  </div>
                </div>
              </div>

            </article>
          ))}
        </div>
      </div>
    </section>
  );
}